// console.log('start cloc');
function gatgetClock (tCl) {
    setInterval(function () {
        var clock = $(tCl),
            d = new Date(),
            hour = d.getUTCHours(),
            m = d.getMinutes(),
            s = d.getSeconds(),
            da = d.getDate(),
            mo = d.getMonth()+1,
            y = d.getFullYear();
        hour += Number(clock.attr('data-clock'));
        var h = hour;
        if (h>23) {
            h -= 24;
            da += 1;
        }
        if (h<10) h = '0'+h;
        if (m<10) m = '0'+m;
        if (s<10) s = '0'+s;
        if (da<10) da = '0'+da;
        if (mo<10) mo = '0'+mo;
        while (hour>=12) {
            hour -= 12;
        }
        $(tCl+' .hour').css({'transform': 'rotate('+((hour * 30)+(d.getMinutes()/2))+'deg)'});
        $(tCl+' .min').css({'transform': 'rotate('+(d.getMinutes() * 6)+'deg)'});
        $(tCl+' .sec').css({'transform': 'rotate('+(d.getSeconds() * 6)+'deg)'});
        $(tCl+' .h').html(h);
        $(tCl+' .m').html(m);
        $(tCl+' .s').html(s);
        $(tCl+' .d').html(da);
        $(tCl+' .mo').html(mo);
        $(tCl+' .y').html(y);

    }, 250);
}
$(document).ready(function () {
    gatgetClock ('.cl01');
    gatgetClock ('.cl02');
    gatgetClock ('.cl03');
    gatgetClock ('.cl04');
    gatgetClock ('.cl05');
});